export enum RemindTypeModalModes {
  VIEW = "view",
  CREATE = "create",
  EDIT = "edit",
}
